import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: 'tubr46jz',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'sk5i03zfnn6XneJdA17QcYMKhjS1tF3AruOhmfcFXGujINDiY3JOcpypgQsMRoAitaaYNAfDJ1BA674E2vuF1ljfIWJRPKIwZitW0rZLBDr2Ik1DTiVUCGQJqFHjLy3eQ5wgs0NlRS8AUyrY0e5zvqAXWdhnGMU4kaSrMj4v7qEQcR10tPWG'

});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
